import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Avatar,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Grid,
  Typography,
  TextField
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import LinkIcon from "@mui/icons-material/Link";
import KeyIcon from "@mui/icons-material/Key";
import { GenerateCredentialsButton,AllocateButton,GoToDashboardButton,NameAllocatedButoon } from "../../../../Global_Component/GlobalButtonComponent";
import { SearchBar } from "../../../../Global_Component/CustomInputComponent";
const rows = [
  { id: 1, name: "Atif Khan",appplicationNumber:"1235",industryType:"Food", paymentMode:"online",date:"12/04/2024",status:"completed", mobile: "+91-9897765443", inquiry: "Halal certificate" },
  { id: 2, name: "Talan Curtis",appplicationNumber:"1235",industryType:"Food", paymentMode:"online",date:"12/04/2024",status:"completed", mobile: "+1 (555) 432-1098", inquiry: "Medical tourism assistance" },
  { id: 3, name: "Kadin Geidt",appplicationNumber:"1235",industryType:"Food", paymentMode:"online",date:"12/04/2024",status:"completed", mobile: "+1 (555) 789-0123", inquiry: "Halal certificate" },
  { id: 4, name: "Ahmed Khan",appplicationNumber:"1235",industryType:"Food", paymentMode:"online",date:"12/04/2024",status:"completed", mobile: "+1 (555) 456-7890", inquiry: "Halal certificate" },
  { id: 5, name: "Jakob Bergson",appplicationNumber:"1235",industryType:"Food", paymentMode:"online",date:"12/04/2024",status:"completed", mobile: "+1 (555) 876-5432", inquiry: "Medical tourism assistance" },
];

const ResultTable = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
 <>

<Grid container spacing={0} sx={{display:"flex",my:1,mx:1,alignItems:'center',justifyContent:"space-between"}}>

<Grid sm={3} >
     <Typography variant="h6" color="initial">LEADS</Typography>
   </Grid>

   <Grid sm={3} sx={{mx:3}}>
   <SearchBar/>
   </Grid>
  
</Grid>   

    <TableContainer
    component={Paper}
    sx={{
        borderRadius: 2,
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        overflowX: "auto", // Enable horizontal scrolling
        width: "100%", // Full-width container
        "&::-webkit-scrollbar": {
          height: "6px", // Thin scrollbar height
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#B0BEC5", // Color of the scrollbar thumb
          borderRadius: "3px", // Rounded edges for thumb
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: "#F5F5F5", // Background track color
        },
        scrollbarWidth: "thin", // For Firefox
        scrollbarColor: "#B0BEC5 #F5F5F5", // Thumb and track colors for Firefox
      }}
  >
    <Table
      sx={{
      
        minWidth: "1500px", // Set a minimum width for the table
        flexWrap:"wrap"
      }}
    >
      {/* Table Header */}
      <TableHead sx={{ bgcolor: "#F6F8FA" }}>
        <TableRow>
          <TableCell
            sx={{ fontWeight: 500, color: "#616161", textAlign: "center" }}
          >
            #
          </TableCell>
          <TableCell
            sx={{ fontWeight: 500, color: "#616161", width: "200px" }}
          >
            Company Name
          </TableCell>
          <TableCell sx={{ fontWeight: 500, color: "#616161",width:"150px" }}>App No</TableCell>
          <TableCell sx={{ fontWeight: 500, color: "#616161" }}>Date</TableCell>
          <TableCell sx={{ fontWeight: 500, color: "#616161" }}>Industry</TableCell>
          <TableCell sx={{ fontWeight: 500, color: "#616161" }}>
            Mobile No
          </TableCell>
          <TableCell sx={{ fontWeight: 500, color: "#616161" }}>Status</TableCell>
          <TableCell sx={{ fontWeight: 500, color: "#616161" }}>payment Mode</TableCell>
          <TableCell
            sx={{
              fontWeight: 500,
              color: "#616161",
              textAlign: "right",
            
              width: "400px",
            }}
          >
            Actions
          </TableCell>
        </TableRow>
      </TableHead>
  
      {/* Table Body */}
      <TableBody>
        {rows.map((row, index) => (
          <TableRow key={row.id}>
            {/* ID */}
            <TableCell>{index + 1}</TableCell>
  
            {/* Name with Avatar */}
            <TableCell
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
              }}
            >
              <Avatar
              src="https://designimages.appypie.com/profilepicture/profilepicture-1-head-person.jpg"
                sx={{
                  bgcolor: index % 2 === 0 ? "#FFEBEE" : "#E3F2FD",
                  color: index % 2 === 0 ? "#D32F2F" : "#1976D2",
                  fontWeight: 500,
                  width: 40,
                  height: 40,
                  fontSize: 14,
                }}
              >
                {row.name
                  .split(" ")
                  .map((n) => n[0])
                  .join("")
                  .toUpperCase()}
              </Avatar>
              <span style={{ marginLeft: 10, fontWeight: 500 }}>{row.name}</span>
            </TableCell>
  
            {/* Other Columns */}
            <TableCell sx={{ color: "#374151" }}>
              {row.appplicationNumber}
            </TableCell>
            <TableCell sx={{ color: "#374151" }}>{row.date}</TableCell>
            <TableCell sx={{ color: "#374151" }}>{row.industryType}</TableCell>
            <TableCell sx={{ color: "#374151" }}>{row.mobile}</TableCell>
            <TableCell sx={{ color: "#374151" }}>{row.status}</TableCell>
            <TableCell sx={{ color: "green" }}>{row.paymentMode}</TableCell>
  
            {/* Actions */}
            <TableCell sx={{p:0}}>
            <NameAllocatedButoon label={rows[index+1]?.name } />
              <GoToDashboardButton />
              <IconButton onClick={handleMenuOpen}>
                <MoreVertIcon />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
              >
                <MenuItem onClick={handleMenuClose}>Action 1</MenuItem>
                <MenuItem onClick={handleMenuClose}>Action 2</MenuItem>
              </Menu>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
 </>
  );
};

export default ResultTable;
